var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 171,
    viewBox: "0 0 194 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 171
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_305)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_208_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1326 71.7199C48.1326 69.2035 49.1322 66.7902 50.9115 65.0109C52.6909 63.2316 55.1042 62.2319 57.6205 62.2319H133.524C136.041 62.2319 138.454 63.2316 140.233 65.0109C142.013 66.7902 143.012 69.2035 143.012 71.7199V104.928C143.012 107.444 142.013 109.857 140.233 111.637C138.454 113.416 136.041 114.416 133.524 114.416H115.174C113.536 114.416 111.926 113.991 110.5 113.184C109.074 112.377 107.882 111.214 107.039 109.809L99.638 97.475C99.2162 96.7736 98.6201 96.1932 97.9077 95.7903C97.1953 95.3874 96.3908 95.1756 95.5724 95.1756C94.7539 95.1756 93.9494 95.3874 93.237 95.7903C92.5246 96.1932 91.9285 96.7736 91.5068 97.475L84.1062 109.809C83.2632 111.214 82.0708 112.377 80.645 113.184C79.2192 113.991 77.6087 114.416 75.9702 114.416H57.6205C55.1042 114.416 52.6909 113.416 50.9115 111.637C49.1322 109.857 48.1326 107.444 48.1326 104.928V71.7199ZM56.7334 56.449C58.4658 53.8507 60.8128 51.7201 63.566 50.2463C66.3193 48.7724 69.3937 48.0008 72.5166 48H118.619C121.742 48.0001 124.818 48.7712 127.572 50.2451C130.326 51.719 132.674 53.85 134.407 56.449L138.268 62.2319H52.8765L56.7334 56.449V56.449Z",
    stroke: "white",
    strokeWidth: 9.48796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M15 63.2523C15 58.9821 16.6963 54.8867 19.7158 51.8672C22.7354 48.8477 26.8307 47.1514 31.1009 47.1514H159.908C164.179 47.1514 168.274 48.8477 171.293 51.8672C174.313 54.8867 176.009 58.9821 176.009 63.2523V119.606C176.009 123.876 174.313 127.971 171.293 130.991C168.274 134.01 164.179 135.706 159.908 135.706H128.769C125.989 135.706 123.256 134.986 120.836 133.617C118.417 132.247 116.393 130.274 114.963 127.889L102.404 106.958C101.688 105.768 100.677 104.783 99.4677 104.099C98.2588 103.416 96.8935 103.056 95.5046 103.056C94.1157 103.056 92.7504 103.416 91.5415 104.099C90.3326 104.783 89.3211 105.768 88.6054 106.958L76.0466 127.889C74.6161 130.274 72.5926 132.247 70.1731 133.617C67.7535 134.986 65.0205 135.706 62.2401 135.706H31.1009C26.8307 135.706 22.7354 134.01 19.7158 130.991C16.6963 127.971 15 123.876 15 119.606V63.2523ZM29.5955 37.3379C32.5354 32.9286 36.5181 29.313 41.1903 26.8119C45.8625 24.3108 51.0798 23.0014 56.3794 23H134.614C139.915 23.0001 145.134 24.3088 149.807 26.81C154.481 29.3111 158.465 32.9274 161.406 37.3379L167.959 47.1514H23.0505L29.5955 37.3379V37.3379Z",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_208_305",
    x: -4.43064,
    y: -4.56334,
    width: 200.006,
    height: 171.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.70783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_305"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.41567
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_305",
    result: "effect2_dropShadow_208_305"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.9097
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_305",
    result: "effect3_dropShadow_208_305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_208_305",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaIcon);
export default __webpack_public_path__ + "static/media/meta-icon.00a9b3afae604b495beda127f6d749e0.svg";
export { ForwardRef as ReactComponent };